import { render, staticRenderFns } from "./withdrawMoney-back.vue?vue&type=template&id=0153ffb6&scoped=true&"
import script from "./withdrawMoney-back.vue?vue&type=script&lang=js&"
export * from "./withdrawMoney-back.vue?vue&type=script&lang=js&"
import style0 from "./withdrawMoney-back.vue?vue&type=style&index=0&id=0153ffb6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153ffb6",
  null
  
)

export default component.exports